import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ArrayFieldTitleProps, titleId } from '@rjsf/utils';

export default function ArrayFieldTitleTemplate(props: ArrayFieldTitleProps) {
  const { title, idSchema } = props;
  const id = titleId(idSchema.$id);

  return (
    <Box id={id} mb={1} mt={1} pl={1}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
        {title}
      </Typography>
    </Box>
  );
}
